module.exports = __webpack_public_path__ + "img/img_easypayov.dedac3e9.jpg";